<template>
  <div class="animated fadeIn">
    <b-card>
      <!-- detail search start -->
      <b-card v-show="so.adv">
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label for="opt_date"> Inspection Date
                <b-button size="sm" variant="info" @click="set_sd('', 'created_at')"><i class="fa fa-remove"></i></b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1d', 'created_at')">-1D</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1w', 'created_at')">-1W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1m', 'created_at')">-1M</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('w', 'created_at')">W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('m', 'created_at')">M</b-button>
              </label>
              <b-form inline>
                <date-picker @change="refresh" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="refresh" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
          <!-- <b-col md="6">
            <b-form-group>
              <label for="opt_visit"> Finished Date
                <b-button size="sm" variant="info" @click="set_sd('', 'finished_at')"><i class="fa fa-remove"></i></b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1d', 'finished_at')">-1D</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1w', 'finished_at')">-1W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1m', 'finished_at')">-1M</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('w', 'finished_at')">W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('m', 'finished_at')">M</b-button>
              </label>
              <b-form inline>
                <date-picker @change="refresh" v-model="so.opt.finished_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="refresh" v-model="so.opt.finished_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group>
          </b-col> -->
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label for="opt_site_name">Site Name</label>
              <b-form-input @keydown.enter="refresh" type="text" id="opt_site_name" v-model="so.opt['name']"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label for="opt_site_fqdn">Site FQDN</label>
              <b-form-input @keydown.enter="refresh" type="text" id="opt_site_fqdn" v-model="so.opt['fqdn']"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="2">
            <b-form-group>
              <label for="opt_error">Error</label><br>
              <c-switch v-model="so.opt['error_count']" @change="refresh"  color="warning" label variant="pill" />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group>
              <label for="opt_error">Detect</label><br>
              <c-switch v-model="so.opt['detect_count']" @change="refresh"  color="danger" label variant="pill" />
            </b-form-group>
          </b-col>
          <b-col md="2">
          </b-col>
          <b-col md="6">
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <label for="ph_search_opt_type">Match Type</label>
            <b-form-group>
              <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" name="ph_search_opt_type">
                <b-form-radio value="and">[AND]:Match all</b-form-radio>
                <b-form-radio value="or">[OR]:Match at least one</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>

        <b-form-group class="float-right">
          <b-button size="sm" variant="success" @click="refresh"> Search </b-button>
          <b-button size="sm" variant="warning" @click="reset"> Reset </b-button>
          <b-button size="sm" variant="secondary" @click="search_opt"> Close </b-button>
        </b-form-group>
      </b-card>
      <!-- detail search end -->
      <b-card>
        <b-row v-if="view_only != true">
          <!-- 기본 FQDN 으로만 검색할 것임 -->
          <b-col md="12">
            <autocomplete :autoSelect="true" @update="update" :get-result-value="getResultValue" :disabled="so.adv" :search="typing" placeholder="Typing FQDN, Press Enter" @submit="onSubmit" aria-label="Typing, FQDN you are looking for"></autocomplete>
            <b-btn class="mt-2" block variant="outline-secondary" @click="refresh"><i class="fa fa-refresh"></i></b-btn>
          </b-col>
        </b-row>
        <hr v-if="view_only != true">
        <b-row>
          <b-col md="6">
            <!-- refresh -->
            <span class="text-center" v-b-tooltip.hover title="Can set showing count">
              Show Count
              <select v-model="so.perPage" @change="refresh">
                <option disabled value="10">Default 10</option>
                <!-- <option value=10>10</option> -->
                <option value=50>50</option>
                <option value=100>100</option>
              </select>
            </span>
          </b-col>
          <b-col style="z-index:0;" v-if="view_only != true">
            <b-pagination class="pull-right" size="sm" :total-rows="getRowCount" :per-page="so.perPage" v-model="currentPage" prev-text="Prev" next-text="Next" />
          </b-col>
          <b-col md="6" v-else class="text-right">
            <b-button size="sm" variant="primary" to="/wmds/result">Go to Result</b-button>
          </b-col>
        </b-row>
        <hr>
        <!-- 사이트 점검 정보 -->
        <vcl-facebook v-if="loading" ></vcl-facebook>
        <b-row v-if="model && model.length">
          <item v-show="!loading" v-for="(item, index) in model" :key="index" :item="item" :index="index" @click="select"></item>
        </b-row>
        <b-row v-else class="text-center">
          <b-col>No inspection results of registered site</b-col>
        </b-row>
      </b-card>
    </b-card>
    <!-- <hr>
    <router-view @refresh="refresh()"></router-view> -->
  </div>
</template>

<script>
import Item from './Result.Grid';
import custom from '@/custom';
import codes from '@/codes';
import DatePicker from 'vue2-datepicker';
import { Api  } from '@/service';
import moment from 'moment-timezone'
import { Switch as cSwitch } from '@coreui/vue';
import { VclFacebook } from 'vue-content-loading';
import Autocomplete from '@trevoreyre/autocomplete-vue'
import '@trevoreyre/autocomplete-vue/dist/style.css'
import _ from 'lodash'

export default {
  props : ['view_only', 'max'],
  components: { cSwitch, DatePicker, Item, VclFacebook, Autocomplete },
  data: () => {
    return {
      load_count : 0,
      loading : true,
      currentPage : 1,
      so : Object.assign({}, codes.DEFAULT_OPT, { perPage : 10 }),
      codes,
      item : undefined,
      custom,
      model : [],
      fqdn_list : [] // fqdn 목록
    }
  },
  watch : {
    currentPage() { this.load() }
  },
  computed: {
    getRowCount () { return this.so.totalRows || 0; },
  },
  methods: {
    update() {
      // custom
      let index = _.indexOf(this.fqdn_list, this.so.sv)
      if (_.indexOf(this.fqdn_list, this.so.sv) > -1) {
        this.so.sv = this.fqdn_list[index]
        // console.log(`Selected: ${results[selectedIndex]}`)
      } else { this.so.sv = ''; }
    },
    getResultValue(result) {
      console.log("getresultvalue", result)
      this.so.sv = result
      return result
    },
    onSubmit(result) {
      if(this.so.sv.length < 1 || !result)  { this.so.sv = ''; }
      console.info(this.so.sv, "Submit", this.so.sk);
      this.load();
      this.$emit('refresh')
    },
    typing(input, count = 10) {
      try {
        if(this.so.sk != 'fqdn') { this.so.sk = 'fqdn' }
        this.so.sv = input
        let rs = _.filter(this.fqdn_list, r => r.toLowerCase().startsWith(input.toLowerCase()))
        // console.log('rs', (rs || []).slice(0, count))
        if(rs.length > count) { let list = (rs || []).slice(0, count); list.push('... more ' + Number(rs.length - count)); return list  }
        return rs
      } catch (e) { console.error('typing error', e) }
    },
    select(item) {
      this.item = item;
      this.detail = true;
      console.log("change to", item.fqdn)
      this.$router.push({ name : 'wmds_result', params : { site_id : item.id } })
      // console.log(item)
    },
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        this.so.opt['created_at_ed'] = moment().add(1, "day");
        this.so.opt['match_type'] = 'and';
        this.so.sv = ''
      } else { this.reset(); }
    },
    set_op(k, v) {
      if(k.endsWith('_count')) {
        return { name : k, value : 0, op :  v == true ? '>' : '<=' }
      }
      return { name : k, value : `%${v}%`, op : 'like' }
    },
    set_sd(v, k = 'created_at') {
      let opt = this.so.opt;

      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          // case '+1d' : sd = moment(sd).subtract(-1, 'd'); break;
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt, opt);
    },
    reset() { this.so = Object.assign({}, codes.DEFAULT_OPT, { opt : {} }); this.refresh(); },
    refresh() { this.load(); },
    load(ctx = {}) {
      this.loading = true
        this.so.currentPage = this.currentPage
        let so = {
          target : 'wmds.site', cmd : 'info',
          body : {
            sort : [{ name : "id", op : "desc" }],
            or : [],
            and : []
          },
          offset : (this.so.currentPage-1 || 0) * Number(this.so.perPage), limit: Number(this.so.perPage), // 10 은 나중에 변수 처리해야함.
        }

        if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
        if(this.so.sk && this.so.sk) { so.body.and.push(this.set_op(this.so.sk, this.so.sv, so)); }

        if(this.so.adv && this.so.opt) {
          var k = Object.keys(this.so.opt)
          for (let i = 0; i < k.length; i++) {
            if(k[i] == 'match_type') { continue; }
            let cond = undefined;
            console.log("this.so.opt[k[i]])", moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), k[i].slice(0, 11), k[i] == 'finished_at_ed')

            switch (k[i]) {
              case 'created_at_sd':
                if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "notice"); break; }
                cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
                break;
              case 'created_at_ed':
                if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "notice"); break; }
                cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
                break;
              case 'finished_at_sd':
                if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "notice"); break; }
                cond = { name : k[i].slice(0, 11), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
                break;
              case 'finished_at_ed':
                if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "notice"); break; }
                cond = { name : k[i].slice(0, 11), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
                break;
              default:
                cond = this.set_op(k[i], this.so.opt[k[i]]);
                break;
            }
            if(cond.value == '%%' || cond.value === '') { continue; }
            if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
            else { so.body.or.push(cond) }
          }
        }
      return Api.Manager(so).then(rs => { this.so.totalRows = rs.total; this.$emit('loading', false); this.loading = false; this.model = rs.body ? rs.body : []; })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText))
    },
    load_fqdn() {
        this.so.currentPage = this.currentPage
        let so = {
          target : 'site', cmd : 'list.fqdn',
          body : {
            sort : [{ name : "id", op : "desc" }],
            or : [],
            and : []
          },
        }
      return Api.Manager(so)
        .then(rs => { this.fqdn_list =  rs.body ? rs.body : [] })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText))
    },
    detail(item) { this.$router.push(`result/${item.id}`, item); },
    hideList(e) { this.show = !e; console.log('result.list.vue', 'got event (list show/hide)', !e ? 'show' : 'hide') },
    clear() { this.opt = { group_id : '', group_name : '', site_fqdn : '' }; this.load(true) },
  },
  created() { console.log('wmds_result.vue', 'created'); },
  destroyed() { console.log('wmds_result.vue', 'destroyed'); },
  mounted() {
    console.log('wmds_result.vue', 'mounted');
    this.load();
    setTimeout(this.load_fqdn, 1000)
  },
}
</script>
